module.exports = __webpack_public_path__ + "static/contact-bg-8b933f76f072627a590321d3a0e652a7.png";